import classNames from "classnames";
import React from "react";
import siteConfig from "../../../config/siteConfig";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";
import { ToolNavigationItemType } from "../../../models/navigation/ToolNavigationItemType";
import { ToolItem } from "./ToolItem";

interface Props {
  items: ToolNavigationItem[];
}

const buttonOrder = {
  [ToolNavigationItemType.Language]: "order-1",
  [ToolNavigationItemType.Market]: "order-2",
  [ToolNavigationItemType.Search]: "order-3",
  [ToolNavigationItemType.Stockticker]: "order-last",
  [ToolNavigationItemType.Link]: "order-last"
};

export const MobileToolLinks = (props: Props) => {
  if (!props.items?.length) {
    return null;
  }

  return (
    <ul
      className={classNames(
        "flex flex-col items-start w-full px-4 xl:hidden",
        !siteConfig.isGroup && "bg-brand-primary-95 py-3"
      )}
    >
      {props.items.map((item, index) => (
        <li key={index} className={`py-2 ${buttonOrder[item.type]}`}>
          <ToolItem {...item} targetDevice="mobile" showSeparator={false} />
        </li>
      ))}
    </ul>
  );
};

